import { render } from "./DynamicDocumentList.vue?vue&type=template&id=05b24bbe"
import script from "./DynamicDocumentList.vue?vue&type=script&lang=js"
export * from "./DynamicDocumentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__